define('views/components/store_product/store_products',['require','backbone','views/components/store_product/store_category','marionette','metro','dialogFx','imagesLoaded','jquery-bridget','isotope','text!templates/components/store_product/store_products.html','models/basket_product'],function (require) {

    var Backbone = require('backbone');
    var ChildView = require('views/components/store_product/store_category');

    require('marionette');
    require("metro");
    require("dialogFx");
    require("imagesLoaded");
    require("jquery-bridget");
    require("isotope");


    var temp = require("text!templates/components/store_product/store_products.html");
    var BasketProductModel = require('models/basket_product');


    return Backbone.Marionette.CompositeView.extend({
        template: _.template(temp),
        tagName: 'div',
        className: "store",
        childViewContainer: '.category_gallery',
        childView: ChildView,
        childViewOptions: function (model, index) {
            return {
                setSelecetedProduct: this.setSelecetedProduct
            };
        },
        

        initialize: function () {

            this.selectedProduct = {};
            var _this = this;
            this.setSelecetedProduct = function(obj){
                _this.selectedProduct = obj;
            };
            this.listenTo(this.collection, 'fetch_complete', this._onFetch);
 
            this.collection.fetch();

        },
        ui: function () {
            return {
                addToBasketButton: '.add-to-basket-button2',
                countField: '#item_count'
            };
        },

        events: {
            'click @ui.addToBasketButton': 'addToBasketButtonClicked'
        },

        _onFetch: function () {
            this.render();
        },

        templateHelpers: function () {
            return {
                selectedProduct: this.selectedProduct,
            };
        },

       
        addToBasketButtonClicked: function () {
            var _this = this;

            if (this.ui.countField.val() > 0) {
                var currentBasketProduct = App.context.basket.get('products').filter(function (basketProduct) {
                    return basketProduct.product.id == _this.selectedProduct.id && !basketProduct.license;
                })[0];

                if (currentBasketProduct) {
                    // Product already in basket, if customer context and license type is single, prevent update, else
                    // update count
                    if (((!App.user || App.user.get('customer')) && currentBasketProduct.product.license_type == 1)) {
                        return;
                    }

                    currentBasketProduct.count += parseInt(this.ui.countField.val());
                } else {
                    // Product not in basket, create new entry
                    var basketProduct = new BasketProductModel({
                        product: _this.selectedProduct,
                        count: parseInt(this.ui.countField.val())
                    });

                    App.context.basket.get('products').push(basketProduct.attributes);
                }
                this.ui.countField.val(1);
                $('.close').click();
                App.vent.trigger('basket-updated');
            } else {
                // Invalid count entered
                App.utils.showMessage('warning', App.polyglot.t('invalid_product_count'));
            }
        }
    });
});
